import React, { ReactElement } from 'react';
import { ThresholdConfigSensor } from 'business-dashboard/src/api/thresholdsApi';
import { SensorTypes } from '../../models/commonEnums';
import { ThresholdRange } from '../../models/commonTypeScript';
import { CustomOptions, ThresholdOption } from '../../models/customThresholdModels';
import PrimaryButton from '../buttons/PrimaryButton';
import styles from './ThresholdSetting.module.scss';
import ThresholdSlider from './ThresholdSlider';
import useThresholdSetting from './useThresholdSetting';

export type Props = {
    sensorType: SensorTypes;
    ranges: ThresholdRange[];
    thresholdOptions: ThresholdOption[];
    customOptions?: CustomOptions;
    selectedValues: number[];
    setSelectedValues: (values: number[]) => void;
    buttonText: string;
    loading?: boolean;
    scopeModified?: boolean;
    onSave: (sensorValues: ThresholdConfigSensor) => void;
    isParentScope?: boolean;
    isSaved?: boolean;
    fullwidthButton?: boolean;
    allowedToEdit: boolean;
};

const ThresholdSetting = ({
    sensorType,
    selectedValues,
    setSelectedValues,
    thresholdOptions,
    customOptions,
    ranges,
    buttonText,
    loading,
    onSave,
    scopeModified,
    isParentScope,
    isSaved,
    fullwidthButton,
    allowedToEdit,
}: Props): ReactElement => {
    const { sortedThresholdOptions, onSaveClicked, notModified, validateInputValues } = useThresholdSetting({
        onSave,
        thresholdOptions,
        customOptions,
        scopeModified,
        sensorType,
        selectedValues,
        isSaved,
    });

    return (
        <div className={styles.thresholdSetting}>
            <div className={styles.slider}>
                <ThresholdSlider
                    sensorType={sensorType}
                    ranges={ranges}
                    thresholdOptions={sortedThresholdOptions}
                    staticValues={isParentScope || !allowedToEdit}
                    selectedValues={selectedValues}
                    setSelectedValues={setSelectedValues}
                    customOptions={customOptions}
                />
            </div>
            {(!isParentScope || (isParentScope && !notModified)) && (
                <div className={styles.button}>
                    <PrimaryButton
                        fullWidth={fullwidthButton}
                        title={buttonText}
                        disabled={notModified || !validateInputValues()}
                        onClick={onSaveClicked}
                        color="primary"
                        loading={loading && !notModified}
                    />
                </div>
            )}
        </div>
    );
};

export default ThresholdSetting;
